import { Role } from '@customTypes/types';
import { Container, Space } from '@mantine/core';
import React from 'react';

import type { Locale } from '@/shared/contexts';
import { useLocaleContext } from '@/shared/contexts';
import { APP_LANGUAGES } from '@/shared/data/appLanguages';
import { useProfileStore } from '@/shared/store/profileStore';
import { LBSelect } from '@/shared/ui-kit/components';

import styles from './RootLayout.module.css';

export const RootLayout = ({ children }: { children: React.ReactNode }) => {
  const { profile } = useProfileStore();
  const { locale, setLocale } = useLocaleContext();

  const maw = profile?.role === Role.admin ? '100%' : '375px';
  const size = profile?.role === Role.admin ? 'xl' : 'lg';

  return (
    <Container
      className={styles.container}
      id='container-root-layout'
      maw={maw}
      size={size}
    >
      {import.meta.env.MODE === 'development' && (
        <LBSelect
          allowDeselect={false}
          data={APP_LANGUAGES}
          defaultValue={locale}
          style={{ width: '75px' }}
          onChange={(value) => setLocale(value as keyof Locale)}
        />
      )}

      {profile?.role !== Role.admin && <Space h={10} />}
      {children}
      {profile?.role !== Role.admin && <Space h={50} />}
    </Container>
  );
};
